export default {
    goals_list: {
        investigating : {
            name: 'Investigate and learn more about Comprehensive Assessment Planning',
            recommendations: [
                'preact',
                'act_district',
                'act_instructional_mastery',
                'act_workkeys',
                'mosaic_sel'
            ]
        },
        writing : {
            name: 'Write or adjust our school improvement plan to include data for college and career readiness',
            recommendations: [
                'preact',
                'act_district',
                'act_workkeys',
                'mosaic_sel',
            ]
        },
        connecting : {
            name: 'Connect and learn more about K12 curriculum and assessments in my school with a goal for college and career readiness',
            recommendations: [
                'preact',
                'act_district',
                'act_instructional_mastery',
                'act_workkeys'
            ]
        },
        improving : {
            name: 'Improve ACT test scores',
            recommendations: [
                'preact',
                'act_online_prep',
                'act_instructional_mastery'
            ]
        },
        develop : {
            name: 'Develop Social and Emotional Learning skills',
            recommendations: [
                'mosaic_sel'
            ]
        },
        measuring : {
            name: 'Measure career readiness',
            recommendations: [
                'act_workkeys',
                'act_workkeys_curriculum',
                'act_district',
                'preact',
                'mosaic_sel'
            ]
        },
        identify : {
            name: 'Identify and address gaps in learning',
            recommendations: [
                'act_district',
                'preact',
                'act_online_prep',
                'mosaic_sel'
            ]
        },
        other : {
            name: 'Other',
            recommendations: [
                'preact',
                'act_district',
                'act_instructional_mastery',
                'act_online_prep',
                'act_workkeys',
                'mosaic_sel',
                'act_workkeys_curriculum'
            ]
        }
    },

    grades_list: {
        '12': {
            'nicename': '12th Grade',
            'recommendations': [
                'mosaic_sel',
                'act_district',
                'act_workkeys',
                'act_workkeys_curriculum',
                'act_online_prep',
                'act_instructional_mastery'
            ]
        },
        '11': {
            'nicename': '11th Grade',
            'recommendations': [
                'mosaic_sel',
                'act_district',
                'act_workkeys',
                'act_workkeys_curriculum',
                'act_online_prep',
                'act_instructional_mastery'
            ]
        },
        '10': {
            'nicename': '10th Grade',
            'recommendations': [
                'preact',
                'act_district',
                'mosaic_sel',
                'act_instructional_mastery'
            ]
        },
        '9': {
            'nicename': '9th Grade',
            'recommendations': [
                'mosaic_sel',
                'preact'
            ]
        },
        '8': {
            'nicename': '8th Grade',
            'recommendations': [
                'mosaic_sel',
                'preact'
            ]
        },
        '7': {
            'nicename': '7th Grade',
            'recommendations': [
                'mosaic_sel'
            ]
        },
        '6': {
            'nicename': '6th Grade',
            'recommendations': [
                'mosaic_sel'
            ]
        },
        '5': {
            'nicename': '5th Grade',
            'recommendations': [
                'mosaic_sel'
            ]
        },
        '4': {
            'nicename': '4th Grade',
            'recommendations': [
            ]
        },
        '3': {
            'nicename': '3rd Grade',
            'recommendations': [
                'mosaic_sel'
            ]
        },
        '2': {
            'nicename': '2nd Grade',
            'recommendations': [
                'mosaic_sel'
            ]
        },
        '1': {
            'nicename': '1st Grade',
            'recommendations': [
                'mosaic_sel'
            ]
        },
        'K': {
            'nicename': 'Kindergarten',
            'recommendations': [
                'mosaic_sel'
            ]
        }
    },

    tools_list: {
        act_aspire_summative: {
            name: 'ACT® Aspire® Summative',
            logo: 'logo-act-aspire.png',
            url: 'https://www.act.org/content/act/en/products-and-services/act-aspire/about-act-aspire/summative-assessments.html',
            description: 'Track students’ academic progress from elementary to high school with the only longitudinal assessment system directly connected to the most used college entrance exam, the ACT test.',
            resources: [
                {
                    label: 'ACT Aspire Periodic',
                    url: 'https://www.act.org/content/act/en/products-and-services/act-aspire/about-act-aspire/periodic-assessments.html'
                },
                {
                    label: 'ACT Aspire Training & Resources',
                    url: 'https://www.act.org/content/act/en/products-and-services/act-aspire/resources.html'
                }
            ],
            frameworks: [0,1],
            purposes: [

            ],
            grades: ['10','9','8','7','6','5','4','3'],
            deprecated: true
        },
        act_aspire_periodic: {
            name: 'ACT® Aspire® Periodic',
            logo: 'logo-act-aspire.png',
            url: 'https://www.act.org/content/act/en/products-and-services/act-aspire/about-act-aspire/periodic-assessments.html',
            description: 'Produce snapshots of students’ academic achievement at intervals throughout the academic year for a more targeted and responsive program of instruction.',
            resources: [
                {
                    label: 'ACT Aspire Summative',
                    url: 'https://www.act.org/content/act/en/products-and-services/act-aspire/about-act-aspire/summative-assessments.html'
                },
                {
                    label: 'ACT Aspire Training & Resources',
                    url: 'https://www.act.org/content/act/en/products-and-services/act-aspire/resources.html'
                }
            ],
            frameworks: [0,1],
            purposes: [

            ],
            grades: ['10','9','8','7','6','5','4','3'],
            deprecated: true
        },
        preact: {
            name: 'PreACT® Assessments',
            logo: 'logo-preact.png',
            url: 'https://www.act.org/content/act/en/products-and-services/preact.html',
            description: 'Provide a powerful, simulated testing experience for the ACT with a predicted ACT score and data to prepare students for life after high school.',
            resources: [
                {
                    label: 'PreACT 8/9 Resources',
                    url: 'https://www.act.org/content/act/en/products-and-services/preact-8-9/resources.html'
                },
                {
                    label: 'PreACT Resources',
                    url: 'https://www.act.org/content/act/en/products-and-services/preact/resources.html'
                }
            ],
            frameworks: [0, 1, 3],
            recommendation_text: {
                0: 'PreACT is aligned to the ACT College and Career Readiness Standards and measures the four core content areas: math, science, reading, and English.',
                1: 'Students with strong cross-cutting capabilities, such as problem solving and critical thinking skills, perform better on the PreACT.',
                3: 'PreACT reports include ACT Interest Inventory results that provide students and their teachers with a personalized view of student interests with college and career alignment.'
            },
            purposes: [
                'college_readiness',
                'core',
                'placement',
                'gifted',
                'preparation',
                'improve_engagement',
                'growth_mindset',
                'inclusion_of_science',
                'improve_student_scores',
                'data_to_inform'
            ],
            grades: ['8','9','10']
        },
        preact_89: {
            name: 'PreACT® 8/9',
            logo: 'logo-preact-89.png',
            url: 'https://www.act.org/content/act/en/products-and-services/preact-8-9/resources.html',
            description: 'Set a baseline for students before high school, provide early ACT test practice, and get predicted PreACT and ACT scores with just one test.',
            resources: [
                {
                    label: 'PreACT 8/9 Resources',
                    url: 'https://www.act.org/content/act/en/products-and-services/preact-8-9/resources.html'
                }
            ],
            frameworks: [0,3],
            purposes: [

            ],
            grades: ['8','9'],
            deprecated: true
        },
        act_district: {
            name: 'The ACT® District Testing',
            logo: 'logo-act.png',
            url: 'https://www.act.org/content/act/en/products-and-services/the-act-educator.html',
            description: 'Assess students’ college readiness with a college reportable score and data to inform teaching and learning in your classrooms.',
            resources: [
                {
                    label: 'ACT Online Prep',
                    url: 'https://www.act.org/content/act/en/products-and-services/the-act/test-preparation/act-online-prep/act-online-prep-schools.html'
                },
                {
                    label: 'ACT Instructional Mastery',
                    url: 'https://www.act.org/content/act/en/products-and-services/act-certified-educator-k12-schools.html'
                }
            ],
            frameworks: [0,1,3],
            recommendation_text: {
                0: 'The ACT test measures what students have learned throughout high school in the four core content areas: math, science, reading, and English.',
                1: 'Students with strong cross-cutting capabilities, such as problem solving and critical thinking skills, perform better on the ACT test.',
                3: 'The ACT reports include ACT Interest Inventory results that provide students and their teachers with a personalized view of student interests with college and career alignment.'
            },
            purposes: [
                'college_entrance',
                'college_readiness',
                'scholarship',
                'mandated',
                'summative',
                'placement',
                'graduation',
                'gifted',
                'improve_engagement',
                'growth_mindset',
                'remove_barriers',
                'inclusion_of_science',
                'dual_enrollment',
                'online_testing',
                'improve_student_scores',
                'data_to_inform'
            ],
            grades: ['12','11', '10']
        },
        act_instructional_mastery: {
            name: 'ACT Instructional Mastery',
            logo: 'logo-act-instructional-mastery.png',
            url: 'https://www.act.org/content/act/en/products-and-services/act-certified-educator/k12-schools.html',
            description: 'Provide your educators with professional learning in a holistic understanding of the ACT® test. Educators will learn teaching strategies that advance students’ abilities to successfully master the core skills needed for college success.',
            resources: [],
            frameworks: [3],
            purposes: [
                'preparation'
            ],
            grades: ['10','11','12']
        },
        act_workkeys: {
            name: 'ACT® WorkKeys®',
            logo: 'logo-act-workkeys.png',
            url: 'https://www.act.org/content/act/en/products-and-services/workkeys-for-educators.html',
            description: 'Ensure your students are career ready and boost their employability with a system of assessments and curriculum that builds and measures and certifies their essential workplace skills.',
            resources: [
                {
                    label: 'ACT WorkKeys Curriculum',
                    url: 'https://www.act.org/content/act/en/products-and-services/workkeys-for-educators/curriculum.html'
                },
                {
                    label: 'ACT National Career Readiness Certificate',
                    url: 'https://www.act.org/content/act/en/products-and-services/workkeys-for-educators/ncrc.html'
                }
            ],
            frameworks: [0,1,3],
            recommendation_text: {
                0: 'ACT WorkKeys is a system of assessments that builds and measures and certifies essential workplace skills including Applied Math, Graphic Literacy, and Workplace Documents.',
                1: 'Students with strong cross-cutting capabilities, such as problem solving and critical thinking skills, perform better on ACT WorkKeys.',
                3: 'ACT WorkKeys is a system of assessments and curriculum that build and measure essential workplace skills that can affect your job performance and increase opportunities for career changes and advancement.'
            },
            purposes: [
                'graduation',
                'foundational'
            ],
            grades: ['12','11']
        },
        act_tessera: {
            name: 'ACT® Tessera™',
            logo: 'logo-act-tessera.png',
            url: 'https://www.act.org/content/act/en/products-and-services/act-tessera.html',
            description: 'Measure, evaluate, and remediate 6–12th grade students’ social and emotional learning skills.',
            resources: [
                {
                    label: 'ACT Tessera Teacher Playbook',
                    url: 'https://pages2.act.org/teacher-playbook-preview.html'
                },
                {
                    label: 'ACT Tessera Resources',
                    url: 'https://www.act.org/content/act/en/products-and-services/act-tessera/resources.html'
                }
            ],
            frameworks: [2],
            purposes: [

            ],
            grades: ['12','11','10','9','8','7','6'],
            deprecated: true
        },
        mosaic_sel: {
            name: 'Mosaic™ by ACT® Social Emotional Learning',
            logo: 'logo-mosaic-sel.png',
            url: 'https://www.act.org/content/act/en/learning-solutions/social-emotional-learning.html',
            description: 'Develop SEL skills that underpin academic success in grades K-12 and drive tangible results using flexible, adaptable assessment, screener, curriculum, and professional development to prepare all students for lifelong success.',
            resources: [
                {
                    label: 'SEL Educator Program',
                    url: 'https://www.act.org/content/act/en/learning-solutions/social-emotional-learning/professional-development.html'
                },
                {
                    label: 'Success Story: SEL Skills on a Virtual Platform',
                    url: 'https://www.act.org/content/dam/act/unsecured/documents/pdfs/Mosaic-by-ACT-SuccessStory-McPherson.pdf'
                }
                ,{
                    label: 'eBook: SEL + MTSS',
                    url: 'https://www.act.org/content/dam/act/unsecured/documents/learning/MTSS-eBook-Mosaic.pdf'
                }
            ],
            frameworks: [1, 2],
            recommendation_text: {
                1: 'Mosaic™ by ACT® Social Emotional Learning teaches cross-cutting capabilities including collaborative problem solving, learning skills and thinking skills.',
                2: 'Mosaic™ by ACT® Social Emotional Learning is a comprehensive assessment, screener, and curriculum solution that builds upon the five core CASEL competencies to drive positive gains in academic achievement and student well-being.'
            },
            purposes: [
                'college_readiness',
                'mandated',
                'mtss',
                'social',
                'foundational',
                'improve_engagement',
                'growth_mindset'
            ],
            grades: ['12','11','10','9','8','7','6','5','4','3','2','1','K']
        },
        mosaic_adaptive: {
            name: 'Mosaic™ by ACT Adaptive Academic Learning',
            logo: 'logo-mosaic-academic.png',
            url: 'https://www.act.org/content/act/en/learning-solutions/adaptive-academic-learning.html',
            description: 'Deliver personalized diagnostics, continuously adaptive enrichment, scaffolded support, and automatic assessment to ensure mastery for every student.',
            resources: [
                {
                    label: 'Mosaic by ACT Adaptive Academic Resources',
                    url: 'https://www.act.org/content/act/en/learning-solutions/adaptive-academic-learning/resources.html'
                }
            ],
            frameworks: [0, 1],
            recommendation_text: {
                0: 'Mosaic™ by ACT® Adaptive Academic Learning adapts in real-time to meet K-8 students exactly where they are with the right level of practice, instruction, scaffolded support, and assessment to ensure they master every Math and ELA concept.',
                1: 'Mosaic™ by ACT® Adaptive Academic Learning teaches cross-cutting capabilities such as technology and information literacy.'
            },
            purposes: [],
            grades: ['8','7','6','5','4','3','2','1','K'],
            deprecated: true
        },

        act_academy: {
            name: 'ACT® Academy™',
            logo: 'logo-act-academy.png',
            url: 'https://www.act.org/content/act/en/products-and-services/act-academy-k12.html',
            description: 'Create lesson plans, assign homework, and give quizzes with this blended learning solution driven by FREE resources personalized to student learning gaps at all points from kindergarten to graduation.',
            resources: [
                {
                    label: 'ACT Academy Blended Learning Instructions',
                    url: 'https://www.act.org/content/dam/act/unsecured/documents/ACT-Academy-Educator-Instructions.pdf'
                }
            ],
            frameworks: [0,1,3],
            purposes: [

            ],
            grades: ['K','1','2','3','4','5','6','7','8','9','10','11','12'],
            deprecated: true
        },
        act_online_prep: { 
            name: 'ACT® Online Prep™',
            logo: 'logo-act-online-prep.png',
            url: 'https://www.act.org/content/act/en/products-and-services/the-act/test-preparation/act-online-prep/act-online-prep-schools.html',
            description: 'Prepare students for the ACT with an engaging, interactive test prep program with flexible, personalized learning paths customized to each student’s needs and test timeframe.',
            resources: [
                {
                    label: 'The ACT District Testing',
                    url: 'https://www.act.org/content/act/en/products-and-services/the-act-educator/states-and-districts.html'
                },
                {
                    label: 'ACT Instructional Mastery',
                    url: 'https://www.act.org/content/act/en/products-and-services/act-certified-educator-k12-schools.html'
                }
            ],
            frameworks: [0,1,3],
            recommendation_text: {
                0: 'ACT Online Prep provides students with personalized study plans aligned to the ACT College and Career Readiness Standards for the four core content areas: math, science, reading, and English.',
                1: 'ACT Online Prep engages student cross-cutting capabilities such as learning, problem solving, and critical thinking skills.',
                2: 'With ACT Online Prep students use behavioral skills such as sustaining effort and keeping an open mind to complete assignments and explore resources at a self-driven pace.',
                3: 'ACT Online Prep provides students with practice for the most used college entrance exam, the ACT test.'
            },
            purposes: [
                'college_readiness',
                'preparation',
                'remove_barriers',
                'improve_student_scores',
                'data_to_inform'
            ],
            grades: ['12','11']
        },
        act_collegeready: { //10
            name: 'ACT® CollegeReady™',
            logo: 'logo-act-college-ready.png',
            url: 'https://www.act.org/content/act/en/products-and-services/act-collegeready/k12.html',
            description: 'Identify knowledge and skill gaps in math and English for college-bound students to create a personalized learning path that empowers students to address their individual academic needs.',
            resources: [],
            frameworks: [],
            purposes: [

            ],
            grades: ['12','11','10'],
            deprecated: true
        },
        act_workkeys_curriculum: {
            name: 'ACT® WorkKeys® Curriculum',
            logo: 'logo-act-workkeys-curriculum.png',
            url: 'https://www.act.org/content/act/en/products-and-services/workkeys-for-educators/curriculum.html',
            description: 'Build the essential career-relevant skills students need for learning, personal development and effective job performance.',
            resources: [
                {
                    label: 'ACT WorkKeys',
                    url: 'https://www.act.org/content/act/en/products-and-services/workkeys-for-educators/assessments.html'
                },
                {
                    label: 'ACT WorkKeys Curriculum Catalog',
                    url: 'https://www.act.org/content/dam/act/unsecured/documents/2021/ACT-WorkKeys-Curriculum-Course-Outlines.pdf'
                },
                {
                    label: 'ACT National Career Readiness Certificate',
                    url: 'https://www.act.org/content/act/en/products-and-services/workkeys-for-educators/ncrc.html'
                }
            ],
            frameworks: [0,1,3],
            recommendation_text: {
                0: 'Courses help individuals build a more solid educational foundation. The courses include Applied Mathematics, Writing, and Applied Technology.',
                1: 'ACT WorkKeys Curriculum delivers a meaningful learning experience and provides students with a customized study schedule. It includes training in problem-solving and critical thinking.',
                2: 'ACT® WorkKeys Curriculum includes soft skills training including customer service, interpersonal and business communications, and working in teams.',
                3: 'ACT® WorkKeys Curriculum provides students with an integrated approach to exploring careers and addresses life and employability skills such as: creating a resume, establishing career goals, and learning financial awareness.'
            },
            purposes: [
                'mtss',
                'foundational'
            ],
            grades: ['12','11']
        },
        psat: {
            name: 'PSAT',
            url: '',
            description: 'The PSAT is a standardized test that many high schools in the United States administer to their 11th grade students.',
            frameworks: [0],
            purposes: [
                'college_readiness',
                'mandated',
                'summative',
                'core',
                'placement',
                'gifted',
                'preparation',
                'improve_student_scores',
                'data_to_inform'
            ],
            grades: ['9','10','11'],
            third_party: true
        },
        sat: {
            name: 'SAT®',
            logo: '',
            url: '',
            description: '',
            frameworks: [0,3],
            purposes: [
                'college_entrance',
                'college_readiness',
                'scholarship',
                'mandated',
                'summative',
                'placement',
                'graduation',
                'gifted',
                'remove_barriers',
                'inclusion_of_science',
                'dual_enrollment',
                'online_testing',
                'improve_student_scores',
                'data_to_inform'
            ],
            grades: ['10','11','12'],
            third_party: true
        },
        other_test_prep: {
            name: 'Other Test Prep',
            logo: '',
            url: 'other-test-prep',
            frameworks: [0],
            purposes: [
                'mtss',
                'preparation',
                'remove_barriers',
                'improve_student_scores'
            ],
            grades: ['K','1','2','3','4','5','6','7','8','9','10','11','12'],
            is_other: true,
            third_party: true
        },
        state_academic_assessment: {
            name: 'State Academic Assessment',
            logo: '',
            url: 'state-academic-assessment',
            description: '',
            frameworks: [0],
            purposes: [
                'college_readiness',
                'mandated',
                'summative',
                'core',
                'placement',
                'graduation',
                'mtss',
                'gifted',
                'remove_barriers',
                'inclusion_of_science',
                'dual_enrollment',
                'online_testing',
                'improve_student_scores',
                'data_to_inform'
            ],
            grades: ['K','1','2','3','4','5','6','7','8','9','10','11','12'],
            is_other: true,
            third_party: true
        },
        other_assessment: {
            name: 'Other Academic Assessment',
            logo: '',
            url: 'other-academic-assessment',
            frameworks: [0],
            purposes: [
                'college_readiness',
                'mandated',
                'summative',
                'core',
                'placement',
                'graduation',
                'mtss',
                'gifted',
                'remove_barriers',
                'inclusion_of_science',
                'dual_enrollment',
                'online_testing',
                'improve_student_scores',
                'data_to_inform'
            ],
            grades: ['K','1','2','3','4','5','6','7','8','9','10','11','12'],
            is_other: true,
            third_party: true
        },
        social_accessment: {
            name: 'Other Social Emotional Learning Solution',
            logo: '',
            url: 'other-social-and-emotional-learning-assessment',
            frameworks: [2],
            purposes: [
                'college_readiness',
                'mandated',
                'mtss',
                'social',
                'foundational',
                'improve_engagement',
                'growth_mindset'
            ],
            grades: ['K','1','2','3','4','5','6','7','8','9','10','11','12'],
            is_other: true,
            third_party: true
        },
        workready_assessment: {
            name: 'Other Work Readiness Assessment',
            logo: '',
            url: 'other-work-readiness-assessment',
            frameworks: [0,3],
            purposes: [
                'mtss',
                'foundational'
            ],
            grades: ['K','1','2','3','4','5','6','7','8','9','10','11','12'],
            is_other: true,
            third_party: true
        },
        college_navigation : {
            name: 'Other College And Career Navigation Tool',
            logo: '',
            url: 'other-college-and-career-navigation-tool',
            frameworks: [3],
            purposes: [
                'mtss',
                'foundational'
            ],
            grades: ['K','1','2','3','4','5','6','7','8','9','10','11','12'],
            is_other: true,
            third_party: true
        }
    },

    purposes_list: {
        college_entrance: {
            name: 'College Entrance Exam',
            description: 'Standardized tests used to evaluate the readiness of students for college admissions purposes.',
            recommendations: [
                'act_district'
            ]
        },
        college_readiness: {
            name: 'College Readiness',
            description: 'The level of preparation a student needs to enroll and succeed—without remediation—in a credit-bearing general education course at a postsecondary institution.',
            recommendations: [
                'act_district',
                'preact',
                'act_online_prep',
                'mosaic_sel'
            ]
        },
        scholarship: {
            name: 'Scholarship Qualification',
            description: 'Scores from these assessments have become a qualifier for certain scholarships.',
            recommendations: [
                'act_district'
            ]
        },
        mandated: {
            name: 'Mandated for Accountability',
            description: 'School or district is required to give assessment as part of a state or federal accountability mandate.',
            recommendations: [
                'act_district',
                'mosaic_sel'
            ]
        },
        summative: {
            name: 'Summative Measurement of Core Academics',
            description: 'Commonly referred to as "assessment of learning." Assessment typically used once a year to measure student achievement.',
            recommendations: [
                'act_district'
            ]
        },
        core: {
            name: 'Benchmark Measurement of Core Academics',
            description: 'Commonly referred to as "assessment for learning." Assessment used to understand where a student is in their learning - data used to tailor instruction and monitor progress.',
            recommendations: [
                'preact'
            ]
        },
        placement: {
            name: 'Course Placement Exam',
            description: 'Data from exams can assist in placing students into HS or College courses. For example - an assessment can be given to 8th graders, then based on their scores, courses for their first year or HS can be chosen. This is especially helpful for HS\'s who have multiple feeder schools. In addition, data from assessments can be used to assist in dual enrollment, honors, or AP course placement.',
            recommendations: [
                'act_district',
                'preact'
            ]
        },
        graduation: {
            name: 'Graduation Requirement',
            description: 'Some schools or states require that students score at a particular level to be able to graduate from high school.',
            recommendations: [
                'act_district',
                'act_workkeys'
            ]
        },
        mtss: {
            name: 'Solution for Multi-Tiered System of Supports (MTSS) and Response to Intervention (RTI) Implementations',
            description: 'RTI is a model for identifying and addressing the specific academic needs of students. MTSS has a much broader scope - MTSS addresses academic as well as social and emotional areas (non-academic), including behavior and other topics such as attendance.',
            recommendations: [
                'mosaic_sel',
                'act_workkeys_curriculum'
            ]
        },
        gifted: {
            name: 'Gifted and Talented Identification',
            description: 'Data/scores from exams assist in placing students into gifted and talented programs.',
            recommendations: [
                'act_district',
                'preact'
            ]
        },
        social: {
            name: 'Measurement of Social and Emotional Learning',
            description: 'Assessing the development of noncognitive skills and character strengths such as grit, teamwork, resilience, curiosity, and leadership.',
            recommendations: [
                'mosaic_sel'
            ]
        },
        foundational: {
            name: 'Foundational Career Readiness Skills',
            description: 'Foundational skills are the fundamental, portable skills that are essential to conveying and receiving information that is critical to training and workplace success.',
            recommendations: [
                'act_workkeys',
                'act_workkeys_curriculum',
                'mosaic_sel'
            ]
        },
        preparation: {
            name: 'Test Preparation',
            description: 'Designed to help students study and practice for an assessment.',
            recommendations: [
                'preact',
                'act_instructional_mastery',
                'act_online_prep'
            ]
        },
        improve_engagement: {
            name: 'Improve Student Engagement',
            description: 'Increasing the degree of attention, curiosity, interest, optimism, and passion of your students while learning.',
            recommendations: [
                'act_district',
                'preact',
                'mosaic_sel'
            ]
        },
        growth_mindset: {
            name: 'Create a Growth Mindset',
            description: 'Understanding, with effort, it’s possible to increase or grow intelligence levels, talents, and abilities.',
            recommendations: [
                'act_district',
                'preact',
                'mosaic_sel'
            ]
        },
        remove_barriers: {
            name: 'Remove Barriers to Testing',
            description: 'Eliminating obstacles to testing',
            recommendations: [
                'act_district',
                'act_online_prep'
            ]
        },
        inclusion_of_science: {
            name: 'Inclusion of Science Test and STEM Score',
            description: 'Examination includes a science section and associated science, technology, engineering, and mathematics (STEM) score',
            recommendations: [
                'act_district',
                'preact'
            ]
        },
        dual_enrollment: {
            name: 'Dual Enrollment Qualification',
            description: 'Eligibility requirements that enable high school students to take college classes while earning their high school diplomas',
            recommendations: [
                'act_district'
            ]
        },
        online_testing: {
            name: 'Online Testing',
            description: 'A virtual exam conducted remotely on a computer with high-speed internet',
            recommendations: [
                'act_district'
            ]
        },
        improve_student_scores: {
            name: 'Improve Student Scores',
            description: 'Help students increase their test scores',
            recommendations: [
                'act_district',
                'preact',
                'act_online_prep'
            ]
        },
        data_to_inform: {
            name: 'Data to Inform Instruction',
            description: 'Assessments provide significant insight into students’ progress, curriculum effectiveness and teaching strategies',
            recommendations: [
                'act_district',
                'preact',
                'act_online_prep'
            ]
        },
        other: {
            name: 'Other',
            description: 'Any other reason the customer may be using a product/solution',
            recommendations: []
        }
    },

    hollistic_frameworks: [
        'Core Academic Skills',
        'Cross Cutting Capabilities',
        'Behavioral Skills',
        'Education & Career Navigation'
    ],

    hollistic_descriptions: [
        'Core academic skills that are mapped to learning progressions from K-career',
        'Cross-cutting capabilities, such as critical thinking, collaborative problem solving, and information and technology skills',
        'Behavioral skills related to success in education and the workforce',
        'Education and career navigation skills related to exploration, planning, and decision making'
    ]
}
